// removed by extract-text-webpack-plugin
module.exports = {"BreakpointFromMedium":"(min-width: 640px)","NewGrey":"#596067","title":"Gc46870","subtitleContainer":"G327e4b","subtitleP":"Gdeb132 G3a5ce6"};